import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export interface ICampaign {
    action: string
    action_type: string
    background_color: {dark?: string; light?: string}
    background_image: string
    created_at?: string
    language?: string
    end_at: string
    id?: string
    name: string
    sorting: number
    start_at: string
}

export const getCampaign = async (id: string): Promise<ApiRes<ICampaign>> => {
    return await apiGet(API_URL, `admin/campaign/${id}`)
}
